import { addDialog, Dialog } from '@libs/focus-frontend-dialogs/src';
import { ButtonView, Plugin, Range, icons } from 'ckeditor5';

import { Inputs } from './types';

class FileManagerPlugin extends Plugin {
  private range: Range | null = null;

  private handleSelectFile = (src: string, config: Inputs) => {
    this.editor.execute('insertImage', {
      source: [{ src, width: config.width, height: config.height }],
    });

    requestAnimationFrame(() => {
      this.editor.editing.view.focus();
      this.editor.model.change((writer) => {
        if (!this.range) {
          return;
        }

        const currentElement = this.range.getCommonAncestor();
        if (!currentElement) {
          return;
        }

        const newPosition = writer.createPositionAt(currentElement, 'end');
        const newRange = writer.createRange(newPosition);
        writer.setSelection(newRange);
      });
    });
  };

  init() {
    this.editor.ui.componentFactory.add('fileManager', () => {
      const button = new ButtonView();

      button.set({
        label: this.editor.locale.t('Insert image'),
        icon: icons.imageAssetManager,
        tooltip: true,
      });

      button.on('execute', () => {
        this.range = this.editor.model.document.selection.getFirstRange();

        addDialog(Dialog.FileManager, {
          onSelectFile: this.handleSelectFile,
          useCDN: this.editor.config.get('useCDN') ?? false,
        });
      });

      return button;
    });
  }
}

export default FileManagerPlugin;
